import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "../../../../store/hooks";

import { Image } from "antd";
import { selectTemplateEntities, selectTemplateIds } from "../../../../store/roblox/templatesSlice";

import Card from "./_Card";

const _ListGrid = () => {
  const ids           = useAppSelector(selectTemplateIds);
  const templates  = useAppSelector(selectTemplateEntities);

  const renderSticker = (id: EntityId) => {
    const template = templates[id];

    if (!template) {
      return;
    }

    return <Card template={template} key={`template-${id}`} />;
  }

  return (
    <>
      <Image.PreviewGroup>
        {ids && ids.map(renderSticker)}
      </Image.PreviewGroup>
    </>
  );
}

export default _ListGrid;
